export const MAP_WIDTH = 200;
export const MAP_HEIGHT = 200;
